<script setup lang="ts"></script>

<template>
  <img
    :src="require('images/loader.png')"
    class="h-10 w-10 animate-spin md:h-20 md:w-20"
  >
</template>
